import { useState, useRef } from 'react';
import { createPortal } from 'react-dom';

interface IntroVideoProps {
  onComplete: () => void;
}

export function IntroVideo({ onComplete }: IntroVideoProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  // Detect mobile immediately on first render to avoid source change
  const [isMobile] = useState(() => typeof window !== 'undefined' && window.innerWidth < 768);

  const handleCanPlay = () => {
    // Play when video is ready - this works better on mobile
    if (videoRef.current) {
      videoRef.current.play().catch(() => {
        // If autoplay fails (e.g., due to browser policy), skip to complete
        onComplete();
      });
    }
  };

  const videoSrc = isMobile ? '/videos/intro-mobile.mp4' : '/videos/intro-desktop.mp4';

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black">
      <video
        ref={videoRef}
        src={videoSrc}
        className="h-full w-full object-contain"
        autoPlay
        playsInline
        muted
        preload="auto"
        onCanPlay={handleCanPlay}
        onEnded={onComplete}
        onError={onComplete}
      />

      {/* Skip button */}
      <button
        onClick={onComplete}
        aria-label="דלג על הסרטון"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 rounded-full bg-white/20 px-6 py-2 text-sm font-medium text-white backdrop-blur-sm transition-[background-color,transform] hover:bg-white/30 active:scale-[0.96]"
      >
        דלג
      </button>
    </div>,
    document.body
  );
}
